import { Box, Typography } from "@mui/material";
import { Link, useNavigate, useParams } from "react-router-dom";
import Row from "../components/Row";
import { formatDatePtBr } from "../utils/dateUtils";
import { colors, USER_DATA } from "../utils/constants";

import * as React from "react";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ButtonLoading from "../components/ButtonLoading";
import { Event } from "../interfaces/Event";
import {
  getEventDetails,
  getUserCheckins,
  saveCheckin,
  trackCertificate,
} from "../api/events";
import { toast } from "react-toastify";
import Input from "../components/Input";
import "../screens/index.css";
import moment from "moment-timezone";
import Loading from "../components/Loading";
import { generateCertificatePdfImagePromiss } from "../utils/certificate";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ViewListIcon from "@mui/icons-material/ViewList";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";

export default function EventDetails() {
  let navigate = useNavigate();

  const { client_id, id } = useParams();

  const [open, setOpen] = React.useState(false);
  const [openDialogCertificate, setOpenDialogCertificate] =
    React.useState(false);
  const [openDialogName, setOpenDialogName] = React.useState(false);
  const [openDialogWhatsapp, setOpenDialogWhatsapp] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [loadingCertificate, setLoadingCertificate] = React.useState(false);

  const [viewMode, setViewMode] = React.useState("list"); // 'list' ou 'card'

  const [event, setEvent] = React.useState<Event | null>(null);
  const [userCheckins, setUserCheckins] = React.useState<any | null>(null);

  const userData = localStorage.getItem(USER_DATA) || "{}";

  let name;

  if (userData) {
    name = JSON.parse(userData).name;
  }

  const [nameCertificate, setNameCertificate] = React.useState(name);
  const [codeDay, setCodeDay] = React.useState("");
  const [daySelected, setDaySelected] = React.useState<any>(null);

  React.useEffect(() => {
    fetchEventDetails();
  }, []);

  const fetchEventDetails = async () => {
    setLoading(true);

    await getEventDetails(client_id, id)
      .then((data) => {
        setEvent(data);
        fetchUserCheckins();
      })
      .catch((err) => console.log(err));
  };

  const fetchUserCheckins = async () => {
    await getUserCheckins(JSON.parse(userData).uid, id as string)
      .then((data) => {
        setUserCheckins(data);
        setLoading(false);
      })
      .catch((err) => console.log(err));
  };

  const doCheckin = () => {
    setLoading(true);
    if (codeDay === daySelected?.code) {
      saveCheckin(JSON.parse(userData).uid, id, daySelected?.id as string)
        .then(() => {
          toast.success("Checkin realizado com sucesso");
          setOpen(false);
          setCodeDay("");
          reload();
        })
        .catch(() => {
          toast.error("Erro ao realizar checkin. Tente novamente");
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      toast.error("Código inválido");
      setLoading(false);
    }
  };

  const reload = () => {
    fetchEventDetails();
  };

  const handleClickOpen = (day: Event) => {
    if (
      JSON.parse(userData).whatsapp == "" ||
      JSON.parse(userData).whatsapp == null ||
      !JSON.parse(userData).whatsapp
    ) {
      setOpenDialogWhatsapp(true);
      return;
    }

    setDaySelected(day);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setCodeDay("");
  };

  const handleCloseDialogCertificate = () => {
    setOpenDialogName(false);
    setOpenDialogCertificate(false);
  };

  const saveNameCertificate = () => {
    setOpenDialogCertificate(true);
    setOpenDialogName(false);
  };

  const renderDays = (day: any) => {
    const today = moment.tz("America/Sao_Paulo").startOf("day");
    const dateDayEvent = moment(day.date)
      .tz("America/Sao_Paulo")
      .startOf("day");

    const inProgress = today.isSame(dateDayEvent);

    const past = today.isAfter(dateDayEvent);

    const realized = userCheckins?.some((e: any) => e.day_id === day.id);

    return (
      <Box
        key={day.id}
        style={{ ...styles.dayContainer, opacity: past ? 0.5 : 1 }}
        className="day-container dashboard-card"
      >
        <Box style={styles.dayTitleContainer} className="day-title-container">
          <span style={styles.eventTitle}>{day.title}</span>
          <span style={styles.eventSubtitle}>
            {formatDatePtBr(new Date(day.date))}
          </span>
        </Box>

        {!inProgress && !realized && !past && (
          <Box style={styles.statusWrap}>
            <span style={styles.waitingStatus}>
              <HourglassEmptyIcon sx={{ fontSize: 18 }} /> Aguardando evento
            </span>
          </Box>
        )}

        {inProgress && !realized && (
          <ButtonLoading
            label={"Fazer checkin"}
            onClick={() => handleClickOpen(day)}
            disabled={!inProgress}
            className="landing-hover-lift"
            style={{
              ...styles.button,
              backgroundColor: colors.status.green,
            }}
          />
        )}

        {!inProgress && !realized && past && (
          <Box style={styles.statusWrap}>
            <span style={styles.lostCheckin}>
              <WarningAmberIcon sx={{ fontSize: 18 }} /> Checkin perdido
            </span>
          </Box>
        )}

        {realized && (
          <Box style={styles.statusWrap}>
            <span style={styles.realizedCheckin}>
              <CheckCircleOutlineIcon sx={{ fontSize: 18 }} /> Checkin
              realizado
            </span>
          </Box>
        )}
      </Box>
    );
  };

  const renderDaysCard = (day: any) => {
    const today = moment.tz("America/Sao_Paulo").startOf("day");

    const dateDayEvent = moment(day.date)
      .tz("America/Sao_Paulo")
      .startOf("day");

    const inProgress = today.isSame(dateDayEvent);
    const past = today.isAfter(dateDayEvent);
    const realized = userCheckins?.some((e: any) => e.day_id === day.id);

    return (
      <Box
        key={day.id}
        style={{ ...styles.dayContainerCard, opacity: past ? 0.5 : 1 }}
        className="day-container dashboard-card"
      >
        <Box style={styles.dayTitleContainer} className="day-title-container">
          <span style={styles.eventTitle}>{day.title}</span>
          <span style={styles.eventSubtitle}>
            {formatDatePtBr(new Date(day.date))}
          </span>
        </Box>

        {!inProgress && !realized && !past && (
          <Box style={{ ...styles.statusWrap, justifyContent: "flex-start" }}>
            <span style={styles.waitingStatus}>
              <HourglassEmptyIcon sx={{ fontSize: 18 }} /> Aguardando evento
            </span>
          </Box>
        )}

        {inProgress && !realized && (
          <ButtonLoading
            label={"Fazer checkin"}
            onClick={() => handleClickOpen(day)}
            disabled={!inProgress}
            className="landing-hover-lift"
            style={{
              ...styles.button,
              backgroundColor: colors.status.green,
              marginTop: 16,
            }}
          />
        )}

        {!inProgress && !realized && past && (
          <Box style={{ ...styles.statusWrap, justifyContent: "flex-start" }}>
            <span style={styles.lostCheckin}>
              <WarningAmberIcon sx={{ fontSize: 18 }} /> Checkin perdido
            </span>
          </Box>
        )}

        {realized && (
          <Box style={{ ...styles.statusWrap, justifyContent: "flex-start" }}>
            <span style={styles.realizedCheckin}>
              <CheckCircleOutlineIcon sx={{ fontSize: 18 }} /> Checkin
              realizado
            </span>
          </Box>
        )}
      </Box>
    );
  };

  const elementRef = React.useRef<HTMLDivElement | null>(null);

  const htmlToImageConvert = () => {
    setLoadingCertificate(true);
    if (event) {
      generateCertificatePdfImagePromiss(event, nameCertificate).finally(() => {
        setLoadingCertificate(false);

        toast.success("Certificado gerado com sucesso");
        setOpenDialogCertificate(false);
        saveCertificateTrack();
      });
    }
  };

  const saveCertificateTrack = async () => {
    const track = {
      user_uuid: JSON.parse(userData).uid,
      event_id: id,
      client_id: client_id,
    };

    trackCertificate(track).then(() => {});
  };

  const checkCanDownloadCertificate = () => {
    if (JSON.parse(userData).role == "admin") return true;

    if (!event?.days) return false;

    var canDownload = false;

    for (let index = 0; index < event?.days.length; index++) {
      if (userCheckins?.some((e: any) => e.day_id === event?.days[index].id)) {
        canDownload = true;
      } else {
        canDownload = false;
      }
    }

    if (
      event?.percentPresenceConfig &&
      calculateActualPercentage() >= (event?.percentPresenceConfig || 100)
    ) {
      canDownload = true;
    } else {
      canDownload = false;
    }

    return canDownload;
  };

  const calculateActualPercentage = () => {
    if (!event?.days) return 0;

    var totalDays = event?.days.length;
    var totalCheckins = userCheckins?.length;

    return Math.round((totalCheckins / totalDays) * 100);
  };

  const openCertificateProcess = () => {
    if (
      JSON.parse(userData).whatsapp == "" ||
      JSON.parse(userData).whatsapp == null ||
      !JSON.parse(userData).whatsapp
    ) {
      setOpenDialogWhatsapp(true);
      return;
    }

    if (JSON.parse(userData).role == "admin") {
      setOpenDialogName(true);
    }

    setOpenDialogName(true);
    // checkCertificateGenerated(JSON.parse(userData).uid, id, client_id).then(
    //   (isCertificateGenerated) => {
    //     isCertificateGenerated
    //       ? toast.error("Certificado já gerado para esse evento.")
    //       : setOpenDialogName(true);
    //   }
    // );
  };

  const handleViewChange = (mode: string) => {
    setViewMode(mode);
  };

  const isMobile = window.innerWidth < 768;

  return (
    <Box style={styles.container}>
      <Row>
        <Link to={`/${client_id}`} style={{ textDecoration: "none" }}>
          <Typography
            style={{ ...styles.back, marginLeft: isMobile ? 16 : 96 }}
            className="back"
          >
            <ArrowBackIcon sx={{ fontSize: 18 }} /> Voltar para eventos
          </Typography>
        </Link>
      </Row>

      {loading && <Loading />}

      {!loading && (
        <Box
          sx={{
            paddingLeft: isMobile ? 2 : 12,
            paddingRight: isMobile ? 2 : 12,
          }}
        >
          <Box style={styles.content} className="details-event-content">
            <img
              src={event?.banner}
              style={styles.bannerEvent}
              className="details-event-banner"
            />

            {event && (
              <Box style={styles.infoContent} className="info-content">
                <span style={styles.eventTitle}>{event?.title}</span>
                <span style={styles.eventSubtitle}>{event?.subtitle}</span>
                <span style={styles.eventDate}>
                  <strong>Data início:</strong>{" "}
                  {formatDatePtBr(new Date(event.dateInit))}
                </span>
                <span style={styles.eventDate}>
                  <strong>Data encerramento:</strong>{" "}
                  {formatDatePtBr(new Date(event.dateFinal))}
                </span>

                <ButtonLoading
                  label="Emitir certificado"
                  onClick={openCertificateProcess}
                  disabled={!checkCanDownloadCertificate()}
                  className="landing-hover-lift"
                  style={styles.certificateButton}
                />
              </Box>
            )}
          </Box>

          <Row
            space
            style={{
              alignItems: "center",
              flexWrap: "wrap",
              gap: 16,
              marginTop: 32,
              marginBottom: 8,
            }}
          >
            <Box style={styles.statsRow}>
              <Box style={styles.statChip}>
                <span style={styles.statChipLabel}>Presença necessária</span>
                <span style={styles.statChipValue}>
                  {event?.percentPresenceConfig || 100}%
                </span>
              </Box>
              <Box
                style={{
                  ...styles.statChip,
                  backgroundColor:
                    calculateActualPercentage() >=
                    (event?.percentPresenceConfig || 100)
                      ? "#E9FBEF"
                      : "#EAF4FF",
                }}
              >
                <span style={styles.statChipLabel}>Sua presença</span>
                <span
                  style={{
                    ...styles.statChipValue,
                    color:
                      calculateActualPercentage() >=
                      (event?.percentPresenceConfig || 100)
                        ? colors.status.green
                        : colors.primary,
                  }}
                >
                  {calculateActualPercentage()}%
                </span>
              </Box>
            </Box>

            {!isMobile && (
              <Box style={styles.viewToggle}>
                <Box
                  style={{
                    ...styles.viewToggleButton,
                    ...(viewMode === "list" ? styles.viewToggleButtonActive : {}),
                  }}
                  onClick={() => handleViewChange("list")}
                >
                  <ViewListIcon sx={{ fontSize: 18 }} />
                  <span>Lista</span>
                </Box>
                <Box
                  style={{
                    ...styles.viewToggleButton,
                    ...(viewMode === "card" ? styles.viewToggleButtonActive : {}),
                  }}
                  onClick={() => handleViewChange("card")}
                >
                  <ViewModuleIcon sx={{ fontSize: 18 }} />
                  <span>Card</span>
                </Box>
              </Box>
            )}
          </Row>

          {event &&
            event.days &&
            viewMode === "list" &&
            event.days
              .sort((a: any, b: any) => (a.date > b.date ? 1 : -1))
              .map((day: any) => {
                return renderDays(day);
              })}

          {viewMode === "card" && (
            <Row
              style={{
                width: "100%",
                flexWrap: "wrap",
                flexDirection: "row",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "stretch",
                gap: 16,
                marginTop: 24,
              }}
            >
              {event &&
                event.days &&
                event.days
                  .sort((a: any, b: any) => (a.date > b.date ? 1 : -1))
                  .map((day: any) => {
                    return renderDaysCard(day);
                  })}
            </Row>
          )}
        </Box>
      )}

      {/* /Dialog checkin */}
      <Dialog open={open} onClose={handleClose} PaperProps={styles.dialogPaper}>
        <DialogTitle sx={styles.dialogTitle}>
          Realizar checkin: {daySelected?.title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={styles.dialogText}>
            Insira no campo abaixo o código de checkin informado durante a
            live: {daySelected?.title}
          </DialogContentText>
          <Input
            title="Código de checkin"
            placeholder="Insira o código de checkin"
            value={codeDay}
            onChange={(e) => setCodeDay(e.target.value)}
          />
        </DialogContent>
        <DialogActions style={styles.dialogActions}>
          <ButtonLoading onClick={handleClose} label="Cancelar" isDelete />
          <ButtonLoading
            onClick={doCheckin}
            label="Realizar checkin"
            loading={loading}
          />
        </DialogActions>
      </Dialog>

      {/* /Dialog NAME */}
      <Dialog
        open={openDialogName}
        onClose={handleClose}
        fullWidth
        PaperProps={styles.dialogPaper}
      >
        <DialogTitle sx={styles.dialogTitle}>Nome no certificado</DialogTitle>

        <DialogContent>
          <TextField
            autoFocus
            required
            label="Preencha o nome para o certificado"
            fullWidth
            value={nameCertificate}
            variant="standard"
            onChange={(e) => setNameCertificate(e.target.value)}
          />

          <Box style={styles.dialogWarningBox}>
            <WarningAmberIcon sx={{ fontSize: 18, color: colors.status.red }} />
            <span style={styles.dialogWarningText}>
              Revise o nome no certificado, pois não será possível emitir
              novamente.
            </span>
          </Box>
        </DialogContent>
        <DialogActions style={styles.dialogActions}>
          <ButtonLoading
            onClick={handleCloseDialogCertificate}
            label="Cancelar"
            isDelete
          />
          <ButtonLoading onClick={saveNameCertificate} label="Salvar e emitir" />
        </DialogActions>
      </Dialog>

      {/* /Dialog WHATSAPP */}
      <Dialog
        open={openDialogWhatsapp}
        onClose={() => setOpenDialogWhatsapp(false)}
        fullWidth
        PaperProps={styles.dialogPaper}
      >
        <DialogTitle sx={styles.dialogTitle}>
          <Box style={styles.dialogTitleWithIcon}>
            <WarningAmberIcon sx={{ color: colors.status.yellow }} />
            Whatsapp não preenchido
          </Box>
        </DialogTitle>

        <DialogContent>
          <DialogContentText sx={styles.dialogText}>
            Preencha seu número de Whatsapp para fazer o checkin ou emitir o
            certificado!
          </DialogContentText>
        </DialogContent>
        <DialogActions style={styles.dialogActions}>
          <ButtonLoading
            onClick={handleCloseDialogCertificate}
            label="Cancelar"
            isDelete
          />
          <ButtonLoading
            onClick={() => navigate("/profile")}
            label="Editar Whatsapp"
          />
        </DialogActions>
      </Dialog>

      {/* /Dialog CERTIFICATE */}
      <Dialog
        open={openDialogCertificate}
        onClose={handleClose}
        fullWidth
        PaperProps={styles.dialogPaper}
      >
        <div
          style={{
            ...(styles.certificate as React.CSSProperties),
            backgroundImage: `url(${event?.certificate})`,
          }}
          ref={elementRef}
        >
          <span
            style={{
              ...(styles.certificateName as React.CSSProperties),
              color: event?.colorCertificateConfig,
            }}
          >
            {nameCertificate}
          </span>
        </div>

        <DialogActions>
          <ButtonLoading
            onClick={handleCloseDialogCertificate}
            label="Cancelar"
            isDelete
            style={{ marginTop: 0 }}
          />
          <ButtonLoading
            onClick={htmlToImageConvert}
            label="Fazer download"
            loading={loadingCertificate}
            style={{ marginTop: 0 }}
          />
        </DialogActions>
      </Dialog>
    </Box>
  );
}

const styles: any = {
  container: {
    paddingTop: 100,
    width: "100%",
  },

  content: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    width: "100%",
    gap: 32,
  },

  infoContent: {
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
    paddingLeft: 8,
    maxWidth: 520,
  },

  dayTitleContainer: {
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
    width: "80%",
  },

  back: {
    fontSize: 15,
    fontWeight: 600,
    color: colors.primary,
    alignItems: "center",
    display: "flex",
    gap: 6,
    marginBottom: 24,
    marginLeft: 24,
  },

  bannerEvent: {
    width: "100%",
    maxWidth: 460,
    borderRadius: 16,
    border: "1px solid #E5E9F0",
    boxShadow: "0 10px 24px -14px rgba(20,33,61,.20)",
    objectFit: "cover",
  },

  eventTitle: {
    fontSize: 20,
    fontWeight: 700,
    color: "#14213D",
  },

  eventSubtitle: {
    fontSize: 15,
    fontWeight: 400,
    color: "#5B6472",
    whiteSpace: "pre-line",
    paddingTop: 12,
    paddingBottom: 12,
    lineHeight: 1.5,
  },

  button: {
    width: "100%",
    marginTop: 0,
    color: colors.white,
  },

  certificateButton: {
    width: "100%",
    marginTop: 24,
    color: colors.white,
    borderRadius: 100,
  },

  eventDate: {
    fontSize: 14,
    color: "#5B6472",
    display: "block",
    marginTop: 4,
  },

  dayContainer: {
    marginTop: 16,
    display: "flex",
    backgroundColor: colors.white,
    border: "1.5px solid #E5E9F0",
    padding: 16,
    paddingLeft: 24,
    paddingRight: 24,
    borderRadius: 16,
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    boxShadow: "0 10px 24px -16px rgba(20,33,61,.16)",
  },

  dayContainerCard: {
    marginTop: 0,
    display: "flex",
    backgroundColor: colors.white,
    border: "1.5px solid #E5E9F0",
    padding: 20,
    borderRadius: 16,
    width: "23%",
    minHeight: 180,
    justifyContent: "space-between",
    flexDirection: "column",
    boxShadow: "0 10px 24px -16px rgba(20,33,61,.16)",
  },

  statusWrap: {
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
  },

  waitingStatus: {
    color: "#8A94A6",
    fontWeight: 600,
    fontSize: 14,
    alignItems: "center",
    display: "flex",
    gap: 6,
  },

  realizedCheckin: {
    color: colors.status.green,
    fontWeight: 600,
    fontSize: 14,
    alignItems: "center",
    display: "flex",
    gap: 6,
  },

  lostCheckin: {
    color: colors.status.red,
    fontWeight: 600,
    fontSize: 14,
    alignItems: "center",
    display: "flex",
    gap: 6,
  },

  certificate: {
    width: "100%",
    height: "425px",
    margin: 0,
    padding: 0,
    backgroundPosition: "center",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundColor: "#272323",
  },

  certificateName: {
    width: "100%",
    textAlign: "center",
    position: "absolute",
    top: "40%",
    fontSize: "18px",
    fontWeight: 500,
    color: "white",
    zIndex: 1,
  },

  statsRow: {
    display: "flex",
    flexDirection: "row",
    gap: 20,
    flexWrap: "wrap",
  },

  statChip: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#EAF4FF",
    border: "1px solid #D7E9FF",
    borderRadius: 12,
    padding: "10px 18px",
    minWidth: 150,
  },

  statChipLabel: {
    fontSize: 12,
    fontWeight: 600,
    color: "#5B6472",
  },

  statChipValue: {
    fontSize: 20,
    fontWeight: 700,
    color: colors.primary,
    marginTop: 2,
  },

  viewToggle: {
    display: "flex",
    flexDirection: "row",
    backgroundColor: "#F0F2F5",
    borderRadius: 12,
    padding: 4,
    gap: 4,
  },

  viewToggleButton: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    padding: "8px 16px",
    borderRadius: 10,
    fontSize: 14,
    fontWeight: 600,
    color: "#5B6472",
    cursor: "pointer",
    transition: "all 150ms ease",
  },

  viewToggleButtonActive: {
    backgroundColor: colors.white,
    color: colors.primary,
    boxShadow: "0 4px 10px -4px rgba(20,33,61,.25)",
  },

  dialogPaper: {
    sx: {
      borderRadius: "20px",
    },
  },

  dialogTitle: {
    fontSize: "18px",
    fontWeight: 700,
    color: "#14213D",
  },

  dialogTitleWithIcon: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },

  dialogText: {
    fontSize: "14px",
    color: "#5B6472",
  },

  dialogActions: {
    alignItems: "center",
    display: "flex",
    padding: 24,
    paddingTop: 8,
    gap: 8,
  },

  dialogWarningBox: {
    display: "flex",
    alignItems: "flex-start",
    gap: 8,
    marginTop: 16,
    padding: 12,
    backgroundColor: "#FFF3F3",
    borderRadius: 10,
  },

  dialogWarningText: {
    color: colors.status.red,
    fontSize: 13,
    lineHeight: 1.5,
  },
};
